import React from 'react';
interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  description,
  actions
}: PageHeaderProps) {
  return <div className="mb-5 flex flex-wrap items-end justify-between gap-3" data-id="element-27" data-mp="14aa3jy8fkn81">
      <div data-id="element-28" data-mp="14cd256nnfood">
        <h1 className="text-xl font-semibold tracking-tight text-foreground md:text-2xl" data-id="element-29" data-mp="zbfgul7ceein">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground" data-id="element-30" data-mp="ucvy0to1piui">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2" data-id="element-31" data-mp="pl42s5ty2oy1">{actions}</div>}
    </div>;
}